<template>
  <div>
    <v-row>
      <v-col md="12" class="text-left">
        <p>{{ $t("registerEvent.step_1_subtitle") }}</p>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col lg="4" md="4" class="text-left">
        <v-text-field
          :label="$t('registerEvent.step_1_label_box')"
          :hint="$t('registerEvent.step_1_hint_box')"
          persistent-hint
          outlined
          dense
          v-model="searchPromoter"
        ></v-text-field>
      </v-col>
    </v-row>
    <!-- card results -->
    <v-row class="ma-1">
      <v-col class="pa-0" md="12" v-if="loadingPage">
        <!-- Loader -->
        <v-skeleton-loader
          v-for="n in 3"
          :key="n"
          class="mx-auto"
          type="list-item-avatar-three-line"
        ></v-skeleton-loader>
      </v-col>
      <v-col class="pa-0" md="12" v-else>
        <!-- cards -->
        <v-row justify="center">
          <v-col v-for="(item) in promoterItemsFiltered" :key="`card-promoter-${item.promoterId}`" cols="12">
            <v-card :style="`background: ${colorCard}`">
              <div
                class="d-flex flex-no-wrap justify-space-between"
                :style="{ minHeight: windowWidth >= 600 ? '174px' : '100px' }"
              >
                <v-avatar
                  class="ma-3"
                  :size="windowWidth < 600 ? 80 : 150"
                  tile
                  style="margin-top: auto !important; margin-bottom: auto !important;"
                >
                  <ImageCard
                    :src="`${urlDomain}${item.promoterLinkImage}`"
                    :urlImage="item.promoterLinkImage"
                    class="img-resp"
                  />
                </v-avatar>
                <div style="width: 100%" v-if="windowWidth >= 600">
                  <v-card-title
                    style="padding: 6px 16px 0;"
                  >{{item.promoterLinkName}}</v-card-title>

                  <v-card-actions>
                    <v-btn
                      :color="`${buttonColor}`"
                      class="btn_next"
                      @click="getEventsByPromoter(item)"
                      >{{ $t("registerEvent.register_prom") }}</v-btn
                    >
                  </v-card-actions>

                  <v-card-text
                    v-if="item.events.length > 0"
                    style="padding: 16px 16px 24px;"
                  >
                    <v-row>
                      <v-col class="font-weight-bold pt-0">
                        {{ $t("registerEvent.upcoming_event") }}
                      </v-col>
                      <v-col
                        class="font-weight-bold pt-0"
                        :style="{
                          maxWidth: windowWidth < 900 ? '150px' : '100%',
                        }"
                      >
                        {{ $t("registerEvent.event_date") }}
                      </v-col>
                    </v-row>
                    <v-row
                      v-for="event in item.events.slice(0, 3)"
                      :key="event.eventId"
                    >
                      <v-col style="padding: 0px 12px"
                        >{{ event.eventName }}
                        <span
                          v-if="item.userID != event.userId"
                          style="color: red"
                          >({{ $t("registerEvent.by") }}
                          {{ event.promoterName }})</span
                        ></v-col
                      >
                      <v-col
                        style="padding: 0px 12px"
                        :style="{
                          maxWidth: windowWidth < 900 ? '150px' : '100%',
                        }"
                        >{{
                          event.eventDate | formatDateForHumans(false)
                        }}</v-col
                      >
                    </v-row>
                  </v-card-text>
                </div>
              </div>

              <div
                class="d-flex flex-no-wrap justify-space-between"
                v-if="windowWidth < 600 && item.events.length > 0"
              >
                <div style="width: 100%">
                  <v-card-title
                    style="padding: 6px 16px 0;"
                  >{{item.promoterName}}</v-card-title>

                  <v-card-actions>
                    <v-btn
                      :color="`${buttonColor}`"
                      class="btn_next next_rsp"
                      @click="getEventsByPromoter(item)"
                      >{{ $t("registerEvent.register_prom") }}</v-btn
                    >
                  </v-card-actions>

                  <v-card-text
                    v-if="item.events.length > 0"
                    style="padding: 16px 16px 24px;"
                  >
                    <v-row class="border-bottom">
                      <v-col style="padding: 0px 12px" class="font-weight-bold">
                        {{ $t("registerEvent.upcoming_event") }}
                      </v-col>
                    </v-row>
                    <v-row
                      v-for="event in item.events.slice(0, 3)"
                      :key="event.eventId"
                      class="border-bottom"
                    >
                      <v-col style="padding: 0px 12px">
                        {{ event.eventDate | formatDateForHumans(false) }}
                        <br />
                        {{ event.eventName }}
                        <span
                          v-if="item.userID != event.userId"
                          style="color: red"
                          >({{ $t("registerEvent.by") }}
                          {{ event.promoterName }})</span
                        >
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <WarningAlert v-if="alertCom">
      {{ $t("registerEvent.step_1_hint_empty") }}
    </WarningAlert>
    <v-row>
      <v-col cols="12">
        <v-btn
          :color="`${buttonColor}`"
          class="btn_next my-1"
          @click="goBack"
          >{{ $t("common.back") }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  VRow,
  VCol,
  VTextField,
  VSkeletonLoader,
  VBtn,
  VCard,
  VCardTitle,
  VCardActions,
  VAvatar,
  VCardText,
} from "vuetify/lib";
import GeneralService from "@/services/GeneralService";
import ImageCard from "@/components/ImageCard";
import LocalStorageService from "@/services/LocalStorageService";
import { mapState } from "vuex";
import WarningAlert from '@/components/alert/WarningAlert.vue';

export default {
  components: {
    VRow,
    VCol,
    VTextField,
    VSkeletonLoader,
    VBtn,
    VCard,
    VCardTitle,
    VCardActions,
    VAvatar,
    VCardText,
    ImageCard,
    WarningAlert,
  },
  props: {
    windowWidth: Number,
    loadingProm: Boolean,
    registrationObj: Object
  },
  data() {
    return {
      searchPromoter: "",
      open: [],
      buttonColor: "#000",
      hint: "",
      alert: false,
    };
  },
  computed: {
    promoterItemsFiltered() {
      let _results = [];
      let _results_events = [];
      let _totals = [];
      const promotersFilter = this.registrationObj.promoters.filter((el) => {
        return this.defaultPromoterId.length == 0 || this.defaultPromoterId.includes(el.promoterId);
      });
      _results = promotersFilter.filter(promo =>{
        return (promo.promoterName.toLowerCase().includes(this.searchPromoter.toLowerCase()) || 
              promo.promoterLinkName.toLowerCase().includes(this.searchPromoter.toLowerCase()))
      });
      promotersFilter.forEach((promo) => {
        promo.events.forEach((event) => {
          if (
            event.eventName
              .toLowerCase()
              .includes(this.searchPromoter.toLowerCase()) ||
            event.eventDate
              .toLowerCase()
              .includes(this.searchPromoter.toLowerCase())
          ) {
            _results_events.push(promo);
          }
        });
      });
      //Distinct by promoterId
      _totals.push(..._results, ..._results_events);
      const _filters = Array.from(
        new Set(_totals.map((a) => a.promoterId))
      ).map((promoterId) => {
        return _totals.find((a) => a.promoterId === promoterId);
      });
      let vm = this;
      if (_filters.length == 0) vm.alert = true;
      else vm.alert = false;

      if (!this.$store.state.env.get("VUE_APP_DEFAULT_PROMOTER") || (Array.isArray(this.defaultPromoterId) && this.defaultPromoterId.length > 0)) {
        _filters.sort((a, b) => {
          // If a has promoterId=203, it should appear first
          if (a.promoterId === 203) {
            return -1;
          }
          // If b has promoterId=203, it should appear first
          if (b.promoterId === 203) {
            return 1;
          }
          // Otherwise, sort based on the promoterId value
          return a.promoterId - b.promoterId;
        });
      }
      return _filters;
    },
    ...mapState({
      colorCard: (state) => state.env.get("VUE_APP_COLOR_CARD"),
      urlDomain: (state) => state.env.get("VUE_APP_ROOT"),
      loadingPage: (state) => {
        if(state && state.session) return state.session.loadingPage;
        return true;
      },
      defaultPromoterId: state => {
        let defaultPromoters = state.env.get('VUE_APP_DEFAULT_PROMOTER');
        if (!defaultPromoters || defaultPromoters === '') {
          return [];
        }
        return defaultPromoters.replaceAll('"','')
          .replaceAll("'",'')
          .split(',')
          .filter(el => !!el)
          .map(promoter => parseInt(promoter))
          .filter(id => !isNaN(id));
      },
      defaultRegistration: state => state.env.get('VUE_APP_DEFAULT_REGISTRATION'),
    }),
    alertCom() {
      return this.alert && !this.loadingPage;
    }
  },
  methods: {
    getEventsByPromoter(promo) {
      this.$emit("getEventsByPromoter", promo);
    },
    loadImage(url) {
      const urlImage = GeneralService.cleanImage(
        url,
        this.$store.getters.env.get("VUE_APP_IMAGE_PLACEHOLDER")
      );
      return urlImage;
    },
    goBack() {
      const previusLink = LocalStorageService.getItem("previus_link");
      this.$router.push({ name: previusLink.name, query: previusLink.query, params: previusLink.params });
    },
  },
  created() {
    this.buttonColor = this.$store.getters.env.get("VUE_APP_BUTTON_COLOR");
  },
  watch: {
    promoterItemsFiltered() {},
  },
};
</script>

<style scoped>
.border-bottom { border-bottom: 1px solid rgba(0, 0, 0, 0.12); }
.img-resp .v-image__image { background-size: 100%; }
</style>
